'use strict';

require('../styles/main.scss');
var Backbone = require('backbone');
var $ = require('jquery');

Backbone.$ = $;

require('../styles/fonts/telescope_icons.font.js');
require('./util/mixin.js');
require('./util/plugin.js');
require('./util/modal.js')($);

var VoteWidgetWidget = require('./VoteWidget');

module.exports = function(options) {
    options = options || {};
    var widget = {};

    options.container = options.container || $(document.body);
    options.uniqueId =
    options.uniqueId ||
    $(options.container).attr('id') ||
    (function() {
        var retval = 'vote-widget-';
        if (options.widget_id) {
            retval += options.widget_id + '-';
        } else {
            retval += 'widget-';
        }
        retval += Date.now() % 1e6;
        return retval;
    })();

    var counterView = VoteWidgetWidget(options);
    if (typeof options.onCreated == 'function') {
        options.onCreated(counterView);
    }

    return widget;
};



// WEBPACK FOOTER //
// ./app/scripts/main.js